import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import useRestrictedAction from "../../../../hooks/useRestrictedAction";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import formatDateViewAll from "../../../../utils/formatDateViewAll";
import useCategories from "../../../../utils/useCategories";
import CardContainer from "../../../_utils/CommonViewAllCard/CardContainer";
import TextWithBank from "../../../_utils/CommonViewAllCard/CardSubComponent/TextWithBank";
import TextWithIcon from "../../../_utils/CommonViewAllCard/CardSubComponent/TextWithIcon";
import ICONS from "../../../../assets/Icons";

const BeneficiaryTransactionGridView = ({
  data,
  typepop,
  type,
  onClose,
  currentStatus,
  labelTransactions,
  isLabelClicked,
  filterRef,
  openTransHistory,
  similarTxn,
  handleLabelSelect,
}) => {
  const navigate = useNavigate();
  const categoryMapper = useCategories();
  const benealldata = data;
  const location = useLocation();

  const services = useSelector((state) => state.refreshToken.services);

  const getStatusColor = (status) => {
    switch (status) {
      case "pending":
        return "var(--pending)";
      case "approved":
        return "var(--awaiting)";
      case "denied":
      case "failed":
      case "rejected":
        return "var(--failed)";
      case "abandoned":
        return "var(--abandoned)";
      case "hold":
      case "queued":
        return "var(--queued)";
      default:
        return "var(--settled)";
    }
  };

  const getDistriStatusColor = (status) => {
    switch (status) {
      case "awaiting_verification":
      case "awaiting_funds":
      case "distribution_initiated":
      case "created":
      case "distribution_pending":
      case "approved":
        return "var(--queued)";
      case "denied":
      case "failed":
      case "rejected":
        return "var(--failed)";
      case "abandoned":
        return "var(--abandoned)";
      case "distribution_complete":
        return "var(--settled)";
      default:
        return "var(--text-primary)";
    }
  };

  const { showRestrictedAction } = useRestrictedAction();

  const actionRestricted = () => {
    showRestrictedAction();
  };

  return (
    <div className={`standard-card-alignment gap-x-gap-sm gap-y-gap-md`}>
      {benealldata?.map((transactions) => {
        const categoryIcon = categoryMapper(
          transactions?.category_id?.category_id,
        );
        return (
          <>
            <CardContainer
              filterRef={filterRef}
              hoverHeight={GlobalConfiguration?.beneTxnCardHoverHeight}
              minHeight={GlobalConfiguration.BeneTxnCardMinHeight}
              key={transactions?.txn_id}
              isSelected={
                Array.isArray(labelTransactions) &&
                labelTransactions?.some(
                  (item) => item?.id === transactions?.txn_id,
                )
              }
              onClickHandler={() => {
                const txnDetailsPath = `/beneficiary_transaction_dashboard/beneficiary_transaction_view_all/beneficiary_transaction_detail_page/${transactions.txn_id}`;
                if (type === "bene_account_detail_modal") {
                  actionRestricted();
                  return;
                }

                const options =
                  transactions?.lifecycle_status === "pending" &&
                  services?.includes("ABeneficiaryTxn")
                    ? {
                        state:
                          currentStatus === "require approval"
                            ? "require approval"
                            : transactions?.lifecycle_status,
                      }
                    : {};

                if (similarTxn === "similarTxn") {
                  actionRestricted();
                  return;
                }
                if (typepop === "transactionHistorypopup" && !isLabelClicked) {
                  onClose();
                  navigate(txnDetailsPath, {
                    state: {
                      isViewAll:
                        location.pathname ===
                        "/beneficiary_transaction_dashboard/beneficiary_transaction_view_all"
                          ? true
                          : false,
                    },
                  });
                  window.location.reload();
                  return;
                }
                if (isLabelClicked) {
                  handleLabelSelect?.(transactions);
                  return;
                }

                if (openTransHistory) {
                  onClose();
                }
                navigate(txnDetailsPath, {
                  replace: openTransHistory ? true : false,
                  state: {
                    isViewAll:
                      location.pathname ===
                      "/beneficiary_transaction_dashboard/beneficiary_transaction_view_all"
                        ? true
                        : false,
                    options: options,
                  },
                });
              }}
            >
              <card-body>
                <TextWithIcon
                  type={"Amount"}
                  fontWeight={"semibold"}
                  text={transactions?.amount}
                  subText={"Transaction amount"}
                  textColor={"var(--settled)"}
                  iconComponentArray={[
                    ...(transactions?.confidential_transaction === "Y"
                      ? [
                          {
                            icon: ICONS?.CONFIDENTIAL_TRANSACTION,
                            title: "confidential",
                            isDisabled: false,
                          },
                        ]
                      : []),
                    ...(isLabelClicked
                      ? [
                          {
                            icon:
                              Array.isArray(labelTransactions) &&
                              labelTransactions.some(
                                (item) => item?.id === transactions?.txn_id,
                              )
                                ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                                : ICONS?.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE,
                            isDisabled: false,
                          },
                        ]
                      : []),
                  ]}
                />

                <TextWithIcon
                  text={transactions.beneficiary_account_name}
                  type={"Text"}
                  subText={"Beneficiary name"}
                  fontWeight={"normal"}
                  textColor={"var(--text-primary)"}
                />
                <TextWithBank
                  text={
                    transactions.created_on
                      ? formatDateViewAll(transactions.created_on, false, false)
                      : "Not given"
                  }
                  subText={"Created on"}
                  type={"Text"}
                  src={categoryIcon.url}
                  imgColor={categoryIcon.colour}
                  ifscCode={transactions.beneficiary_account_ifsc_code}
                />
              </card-body>

              <card-hover>
                <TextWithIcon
                  text={
                    currentStatus === "require approval"
                      ? "Require approval"
                      : transactions?.lifecycle_status || "N/A"
                  }
                  subText={"Approval status"}
                  textCase={"capitalize"}
                  fontWeight={"semibold"}
                  textColor={
                    transactions?.lifecycle_status === "N/A"
                      ? "var(--text-primary)"
                      : getStatusColor(transactions?.lifecycle_status)
                  }
                />

                <TextWithIcon
                  text={
                    transactions?.distribution_lifecycle_status === "created"
                      ? "Distribution created"
                      : transactions?.distribution_lifecycle_status ===
                          "awaiting_funds"
                        ? "Awaiting funds"
                        : transactions?.distribution_lifecycle_status ===
                            "distribution_initiated"
                          ? "Distribution initiated"
                          : transactions?.distribution_lifecycle_status ===
                              "abandoned"
                            ? "Distribution abandoned"
                            : transactions?.distribution_lifecycle_status ===
                                "rejected"
                              ? "Distribution rejected"
                              : transactions?.distribution_lifecycle_status ===
                                  "failed"
                                ? "Distribution failed"
                                : transactions?.distribution_lifecycle_status ===
                                    "distribution_complete"
                                  ? "Distribution complete"
                                  : transactions?.distribution_lifecycle_status ===
                                      "approved"
                                    ? "Distribution approved"
                                    : transactions?.distribution_lifecycle_status ||
                                      "N/A"
                  }
                  subText={"Distribution status"}
                  // textCase={"capitalize"}
                  fontWeight={"semibold"}
                  textColor={
                    transactions?.distribution_lifecycle_status === "N/A"
                      ? "var(--text-primary)"
                      : getDistriStatusColor(
                          transactions?.distribution_lifecycle_status,
                        )
                  }
                />

                <TextWithIcon
                  text={
                    transactions?.labels?.join(", ") || "No labels assigned "
                  }
                  fontWeight={"normal"}
                  textColor={"var(--text-primary)"}
                  iconComponentArray={[
                    {
                      icon: ICONS?.LABEL,
                    },
                  ]}
                />
              </card-hover>
            </CardContainer>
          </>
        );
      })}
    </div>
  );
};

export default BeneficiaryTransactionGridView;
